import { Lock } from 'lucide-react';
import { Outlet, useLocation } from 'react-router-dom';

import { Card, CardContent } from '@/components/ui/card';
import { featureForPath } from '@/config/features';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Penjaga halaman untuk modul yang tidak termasuk paket langganan lembaga.
 *
 * Menyembunyikan menunya saja tidak cukup: alamat halaman bisa tersimpan di
 * bookmark, dikirim lewat pesan, atau tertinggal di riwayat peramban sejak
 * lembaga masih memakai paket yang lebih tinggi. Tanpa penjaga ini, halaman
 * tetap terbuka lalu memuntahkan pesan galat dari server — benar secara
 * keamanan, tapi terbaca sebagai aplikasi rusak.
 *
 * Dipasang satu kali di kerangka halaman, bukan dibungkuskan ke tiap rute:
 * pemetaannya berdasarkan awalan alamat, jadi seluruh sub-halaman satu modul
 * ikut terjaga tanpa perlu didaftarkan satu per satu — termasuk halaman yang
 * ditambahkan kemudian.
 */
export function FeatureGate() {
  const location = useLocation();
  const hasFeature = useAuthStore((state) => state.hasFeature);

  const feature = featureForPath(location.pathname);

  if (!feature || hasFeature(feature.key)) {
    return <Outlet />;
  }

  return (
    <Card className="mx-auto max-w-lg">
      <CardContent className="space-y-3 p-8 text-center">
        <Lock className="mx-auto size-8 text-[var(--color-muted-foreground)]" aria-hidden="true" />
        <h1 className="text-lg font-semibold">Fitur {feature.label} tidak aktif</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          Modul ini tidak termasuk dalam paket langganan lembaga Anda. Hubungi admin lembaga untuk meninjau
          paket yang dipakai.
        </p>
      </CardContent>
    </Card>
  );
}
